<template>
  <div class="chart">
    <div class="chart_wrap" v-loading="loading">
      <gas-line-chart :data="item"></gas-line-chart>
    </div>
  </div>
</template>

<script>
import gasLineChart from '@/components/echarts/GasLineChart'

export default {
  props: ['item'],
  components: {
    gasLineChart
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    }
  }
}
</script>

<style lang="scss" scoped>
.chart {
  display: flex;
  flex-wrap: wrap;
  width: 98%;
}

.chart_wrap {
  display: flex;
  width: 100%;
  height: 400px;
  flex-wrap: wrap;
  margin: 30px 1% 0 1%;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  padding: 0px;
  box-sizing: border-box;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/component/base-gas-chart.vue